import React from 'react';
interface IconProps {
  className?: string;
}
export function CheckIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-134">
      <polyline points="20 6 9 17 4 12" data-id="element-135" />
    </svg>;
}
export function ShieldIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-136">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-137" />
      <polyline points="9 12 11 14 15 10" data-id="element-138" />
    </svg>;
}
export function ClockIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-139">
      <circle cx="12" cy="12" r="10" data-id="element-140" />
      <polyline points="12 6 12 12 16 14" data-id="element-141" />
    </svg>;
}
export function BoneIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-142">
      <path d="M18.3 5.7a2.8 2.8 0 0 0-3.9 0l-.4.4-8.3 8.3-.4.4a2.8 2.8 0 1 0 3.9 3.9l.4-.4 8.3-8.3.4-.4a2.8 2.8 0 0 0 0-3.9z" data-id="element-143" />
      <path d="M5.7 5.7a2.8 2.8 0 0 1 3.9 0l.4.4" data-id="element-144" />
      <path d="M18.3 18.3a2.8 2.8 0 0 1-3.9 0l-.4-.4" data-id="element-145" />
    </svg>;
}
export function PawIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-146">
      <ellipse cx="8" cy="7" rx="2" ry="2.5" data-id="element-147" />
      <ellipse cx="16" cy="7" rx="2" ry="2.5" data-id="element-148" />
      <ellipse cx="5" cy="12" rx="1.8" ry="2.2" data-id="element-149" />
      <ellipse cx="19" cy="12" rx="1.8" ry="2.2" data-id="element-150" />
      <path d="M12 22c-3 0-5.5-2.5-5.5-5 0-1.5.8-3 2-4a4.5 4.5 0 0 1 7 0c1.2 1 2 2.5 2 4 0 2.5-2.5 5-5.5 5z" data-id="element-151" />
    </svg>;
}
export function AlertIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-152">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" data-id="element-153" />
      <line x1="12" y1="9" x2="12" y2="13" data-id="element-154" />
      <line x1="12" y1="17" x2="12.01" y2="17" data-id="element-155" />
    </svg>;
}
export function BookIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-156">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" data-id="element-157" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" data-id="element-158" />
      <line x1="8" y1="7" x2="16" y2="7" data-id="element-159" />
      <line x1="8" y1="11" x2="14" y2="11" data-id="element-160" />
    </svg>;
}
export function CartIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-161">
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" data-id="element-162" />
      <line x1="3" y1="6" x2="21" y2="6" data-id="element-163" />
      <path d="M16 10a4 4 0 0 1-8 0" data-id="element-164" />
    </svg>;
}
export function ArrowDownIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-165">
      <line x1="12" y1="5" x2="12" y2="19" data-id="element-166" />
      <polyline points="19 12 12 19 5 12" data-id="element-167" />
    </svg>;
}
export function ChevronDownIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-168">
      <polyline points="6 9 12 15 18 9" data-id="element-169" />
    </svg>;
}
export function StarIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1" data-id="element-170">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-171" />
    </svg>;
}
export function HeartIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-172">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" data-id="element-173" />
    </svg>;
}
export function FlameIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-174">
      <path d="M12 23c-3.87 0-7-3.13-7-7 0-2.38 1.19-4.47 3-5.74C8 10.26 8 9.5 8 9c0-2.21 1.12-4.15 2.83-5.29.43-.29.97.1.84.59C11.17 6.1 12 7.5 12 7.5s1.5-2 1.5-4.5c0-.33.26-.62.58-.67.16-.03.33.02.45.13C17.07 4.82 19 8.13 19 11c0 1.5-.5 3-1.5 4.13-.17.2-.17.47 0 .67.5.6.5 1.5.5 2.2 0 2.76-2.24 5-5 5z" data-id="element-175" />
    </svg>;
}
export function LeafIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-176">
      <path d="M11 20A7 7 0 0 1 9.8 6.9C15.5 4.9 17 3.5 19 2c1 2 2 4.5 2 8 0 5.5-4.78 10-10 10z" data-id="element-177" />
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-178" />
    </svg>;
}
export function XIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-179">
      <line x1="18" y1="6" x2="6" y2="18" data-id="element-180" />
      <line x1="6" y1="6" x2="18" y2="18" data-id="element-181" />
    </svg>;
}
export function SparkleIcon({
  className = ''
}: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" data-id="element-182">
      <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z" data-id="element-183" />
    </svg>;
}